import { AfterViewInit, Component, ElementRef, OnInit, Renderer2, ViewChild,EventEmitter, Input, Output } from '@angular/core';
import { FormGroup, FormControl, Validators, AbstractControl, ValidatorFn, ValidationErrors, FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { interval, switchMap, takeWhile, Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { environment } from "src/environments/environment";
import { CandidatosApiService } from 'src/app/core/services/candidatos-api.service';

@Component({
  standalone: false,
  selector: 'app-solicitud-reset-password',
  templateUrl: './solicitud-reset-password.component.html',
  styleUrl: './solicitud-reset-password.component.scss',
  // imports: [FormStepsComponent], // ⬅️ aquí debe ir
})
export class SolicitudResetPasswordComponent implements OnInit {
  @Output() cambioPaso = new EventEmitter<number>();

  resetPasswordForm: FormGroup;
  showPassword: boolean = false;
  showConfirmPassword: boolean = false;
  codigoEstatusSolicitudCambioPassword: number = 0;

  pasos = ['Solicitud', 'Notificación'];
  pasoActual = 1;
  puedeAvanzar: boolean = true;

  constructor(private fb: FormBuilder, private candidatosApiService: CandidatosApiService) {
    this.resetPasswordForm = this.fb.group({
      email: [''],
      password: ['', [Validators.required, Validators.minLength(8), Validators.pattern(/^(?=.*[A-Za-z])(?=.*\d).{8,}$/)]],
      confirmPassword: ['', [Validators.required]]
    }, { validators: this.passwordsIguales() });
  }

  ngOnInit(): void { }

  actualizarPaso(nuevoPaso: number) {
    if (this.pasoActual === 1) {
      this.envioValidacionEmail();

      this.pasoActual = nuevoPaso;
    }
  }

  envioValidacionEmail() {
    const email = this.resetPasswordForm.get('email')?.value;
    console.log('Email:', email);
    this.candidatosApiService.passwordResetService("1", email).subscribe(
      (data: {}) => {
        let _response: any = data;
        this.codigoEstatusSolicitudCambioPassword = Number(_response.codigo);
      }, (error: {}) => {
        console.error(error);
        this.codigoEstatusSolicitudCambioPassword = 500;
      }
    );
  }

  passwordsIguales(): ValidatorFn {
    return (group: AbstractControl): ValidationErrors | null => {
      const pass = group.get('password')?.value;
      const confirm = group.get('confirmPassword')?.value;
      return pass === confirm ? null : { noCoinciden: true };
    };
  }

  formControl(controlName: string) {
    return this.resetPasswordForm.get(controlName);
  }

  onSubmit() {
    if (this.resetPasswordForm.valid) {
      const newPassword = this.resetPasswordForm.value.password;
      // Aquí puedes enviar al backend
      console.log('Nueva contraseña:', newPassword);
    }
  }

  togglePassword() {
    this.showPassword = !this.showPassword;
  }

  toggleConfirmPassword() {
    this.showConfirmPassword = !this.showConfirmPassword;
  }
}
